import React, { Component } from 'react';

class TravelNewsUpdates extends Component {
    constructor(props) {
        super(props);

        this.state = {
            LatestBlogs: JSON.parse(this.props.blogdata),
            LanguageBasedLabel: [],
        };
    }

    componentDidMount() {
        const message = document.getElementById('langBasedMessage').getAttribute('value');
        const convertedMessage = JSON.parse(message);
        this.setState({ LanguageBasedLabel: convertedMessage });
    }

    render() {
        const { LatestBlogs } = this.state;
        console.log('this.state render', this.state);
        return (
            <>
                <div>
                    <div className="font-weight-bold mb-4">
                        {this.state.LanguageBasedLabel.Travel_News_And_Updates}
                    </div>
                    {
                        (LatestBlogs && LatestBlogs.length > 0 && LatestBlogs != '')
                            ? LatestBlogs.map((value, index) => (
                                <a href={value.link} className="font-weight-bold mb-4 d-inline-block font-size-md" key={index}>{value.title}</a>
                            ))
                            : null
                    }
                </div>
                <div>
                    <a href="#" className="btn btn-warning btn-lg text-balck  font-size-md font-weight-bold rounded-sm mt-1 border-0 py-3 px-4"> {this.state.LanguageBasedLabel.More_News}</a>
                </div>
            </>
        );
    }
}

export default TravelNewsUpdates;
